/** @format */

import SurveyFormTrueBLue from '../../components/survey-form-trueblue/survey-form-trueblue.component';
import PasswordResetPage from '../password-reset-page/password-reset-page.component';
import UsernameResetPage from '../username-reset-page/username-reset-page';
import * as React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Modal from '../../components/modal/modal.component';
// import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { deepmerge } from '@mui/utils';

const CustomerSupportPage = () => {
  let [modalOpen, setModalOpen] = React.useState(false);
  let [modalText, setModalText] = React.useState('Please wait...');
  let [modalLoading, setModalLoading] = React.useState(true);
  return (
    <Container maxWidth="lg">
      {modalOpen && (
        <Modal
          variant="loadingModal"
          type="dropIn"
          handleClose={() => setModalOpen(false)}
          modalOpen={modalOpen}
          text={modalText}
          loading={modalLoading}
        />
      )}
      <FullWidthTabs
        setModalLoading={setModalLoading}
        setModalOpen={setModalOpen}
        setModalText={setModalText}
      />
    </Container>
  );
};

export default CustomerSupportPage;

export const themeOptions = {
  palette: {
    type: 'light',
    primary: {
      main: '#b71c1c',
    },
    secondary: {
      main: '#e0e0e0',
    },
    warning: {
      main: '#ff9100',
    },
  },
};
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

function FullWidthTabs({ setModalOpen, setModalText, setModalLoading }) {
  // let theme = useTheme();
  let theme = createTheme(deepmerge(themeOptions));
  const [value, setValue] = React.useState(0);

  const handleChange = (_event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ bgcolor: 'background.paper', width: '100%' }}>
        <AppBar sx={{ bgcolor: 'background.paper' }} position="static">
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            aria-label="full width tabs example"
          >
            {/* <Tab label="TrueBlue Points" {...a11yProps(0)} /> */}
            <Tab label="Customer Password Reset" {...a11yProps(0)} />
            <Tab label="Customer Username Reset" {...a11yProps(1)} />
          </Tabs>
        </AppBar>
        <SwipeableViews
          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
          index={value}
          onChangeIndex={handleChangeIndex}
        >
          {/* <TabPanel value={value} index={0} dir={theme.direction}>
            <SurveyFormTrueBLue
              setModalOpen={setModalOpen}
              setModalText={setModalText}
              setModalLoading={setModalLoading}
            />
          </TabPanel> */}
          <TabPanel value={value} index={0} dir={theme.direction}>
            <PasswordResetPage
              setModalOpen={setModalOpen}
              setModalText={setModalText}
              setModalLoading={setModalLoading}
            />
          </TabPanel>
          <TabPanel value={value} index={1} dir={theme.direction}>
            <UsernameResetPage
              setModalOpen={setModalOpen}
              setModalText={setModalText}
              setModalLoading={setModalLoading}
            />
          </TabPanel>
        </SwipeableViews>
      </Box>
    </ThemeProvider>
  );
}
